import {PERCORSODRAWER} from './PercorsoDrawerTypes'

const initialState = {
    percorsoDrawer : false
}

const PercorsoDrawerReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case PERCORSODRAWER:
            
            return {
                percorsoDrawer : action.load
            }
    
        default:
          return state
    }

}

export default PercorsoDrawerReducer;